var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('transition',{attrs:{"name":"fade","appear":""}},[_c('img',{attrs:{"src":require('@/assets/images/panel_graphics/magic.png'),"alt":""}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }